import { createStyles, makeStyles } from '@material-ui/styles';
import Dashboard from '../icons/icon-img/dashboard.png'

export const DashboardIcon = () => {
  const useStyles = makeStyles(() => 
    createStyles({
      img: {
        width: '25px',
        height: '25px'
      },
    })
  )
  const classes = useStyles();
  return (
    <>
      <img
      className={classes.img}
      src={Dashboard} 
      alt="" 
      />
    </>
  );
};
